<!-- TelaPrePagamento.svelte -->
<script>
  import { Button } from "@svelteuidev/core";
  import { onDestroy, onMount } from "svelte";
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import Tooltip from "../../componentes_basicos/Tooltip.svelte";
  import ModalPix from "../../componentes_basicos/ModalPix.svelte";
  
  import { navigate } from "svelte-routing";
  import { DadosPaginaAnterior } from "../../Classes/Stores";
  import ArmazenaVariaveisLogin from "../../Classes/ArmazenaVariaveisLogin";
  import Armazena from "../../Classes/ArmazenaVariaveis";
  import ArmazenaVariaveisInscricao from "../../Classes/ArmazenaVariaveisInscricao";
  import ModalCartaoCredito from "../../componentes_basicos/ModalCartaoCredito.svelte";
  export let params;
  export let cod_inscricao_encurtado = params;

  let tempo;

  $: tempo = timeRemaining;

  let api = Constantes.api_consultar_padrao;
  let parametros = {
    query_code: Constantes.query_code_consultar_resumo_pagamento_inscricao,
    cod_inscricao_encurtado: cod_inscricao_encurtado,
    id_usuario: ArmazenaVariaveisLogin.dados.id_usuario,
  };

  let voltarPagina = "/inscricao?id=" + $DadosPaginaAnterior.id_campeonato;
  let conexao = new Conexoes();
  let retorno;
  let isLoading = false;
  let solicitante;
  let descricao;
  let valor_formatado;
  let taxa_inscricao_formatado;
  let taxa_percentual_formatada;
  let taxa_inscricao;
  let taxa_percentual;
  let preco_final_formatado;
  let preco_final;

  let paymentMethod = "";
  let tituloBotao;
  let interval;
  let Banco = "MercadoPago";
  let qrCodeBase64 = "";
  let pixCode = "";
  let tooltipmsg = "";
  let expirationTime = 0;
  let collectorName = "";
  let horaExpiracao = "";
  let mensagem =
    "Inscrição efetuada com sucesso ! Você receberá um email de confirmação. Mas se preferir pode fazer o download do comprovante de inscrição!";
  let result;
  let showModal = false;
  let toastVisible = false;
  let api_pagamento = Constantes.end_point_back_end_mercado_pago;
  let api_pagamento_boleto = Constantes.end_point_back_end_mercado_pago_boleto;
  let parametros_consulta_pagamentos_disponiveis = {
    query_code: Constantes.query_code_pagamentos_disponives,
    cod_inscricao_encurtado: cod_inscricao_encurtado,
  };
  let api_atualiza_pagamento =
    Constantes.end_point_back_end_mercado_pago_atualiza;
  let hora_registro;
  let transaction_amount;
  let timeRemaining = 0;
  let pago = false;
  let messagemExpirado = "";
  let msgAguardandoPagamento = "Aguardando pagamento!";
  let statusPagamento;
  let link_boleto;
  let msgBaixarBoleto;
  let id_pagamento_banco;
  let desconto_cupom_formatado;
  let preco_com_desconto_cupom_formatado;
  let codigo_cupom;

  let cartaoHabilitado = 0;
  let cartaoHabilitado_pro = 0;
  let pixHabilitado = 0;
  let boletoHabilitado = 0;
  let desconto_cupom = 0;
  let modalCartao = false;
  let parametros_pagamento = {
    cod_inscricao_encurtado: cod_inscricao_encurtado,
  };

  //pre pagamento
  async function PegaDados() {
    isLoading = true;
    retorno = await conexao.conecta(api, parametros);
    if (retorno) {
      solicitante = retorno[0].nome_usuario;
      descricao = retorno[0].descricao_inscricao;
      valor_formatado = retorno[0].preco_formatado;
      taxa_inscricao_formatado = retorno[0].taxa_inscricao_formatado;
      taxa_percentual_formatada = retorno[0].taxa_percentual_formatada;
      taxa_inscricao = retorno[0].taxa_inscricao;
      taxa_percentual = retorno[0].taxa_percentual;

      //cupom
      desconto_cupom_formatado = retorno[0].desconto_cupom_formatado;
      desconto_cupom = retorno[0].desconto_cupom;
      preco_com_desconto_cupom_formatado =
        retorno[0].preco_com_desconto_cupom_formatado;
      codigo_cupom = retorno[0].codigo_cupom;

      Banco = retorno[0].nome_banco;
      preco_final_formatado = retorno[0].preco_final_formatado;
      preco_final = retorno[0].preco_final;

      //console.log(retorno[0]);
    }
    isLoading = false;
  }

  onMount(async () => {
    await params;
    cod_inscricao_encurtado = params;
    VerPagamentosDisponiveis();
    PegaDados();
    await AtualizaStatus();
  });
  onDestroy(() => {
    ApagaContador();
  });

  async function VerPagamentosDisponiveis() {
    isLoading = true;
    let r = await conexao.conecta(
      Constantes.api_consultar_padrao,
      parametros_consulta_pagamentos_disponiveis,
    );
    if (r && r.length > 0) {
      cartaoHabilitado = r[0].recebe_cartao;
      cartaoHabilitado_pro = r[0].recebe_cartao_pro;
      pixHabilitado = r[0].recebe_pix;

      console.log("pix habilitado", pixHabilitado);
      boletoHabilitado = r[0].recebe_boleto;

      isLoading = false;
    }
  }

  function ApagaContador() {
    showModal = false;
  }
  function VerBoleto() {
    window.open(link_boleto, "_blank");
  }
  function BaixarBoleto() {
    //console.log("id banco", id_pagamento_banco)
    window.location.href = Constantes.url_baixar_boleto + id_pagamento_banco;
  }
  async function PagamentoBoleto() {
    isLoading = true;
    result = await conexao.conecta(api_pagamento_boleto, parametros_pagamento);

    if (result.status === "pending") {
      //console.log("etrou aqui");

      horaExpiracao = result.date_of_expiration;
      hora_registro = result.hora_criacao_servidor;
      id_pagamento_banco = result.id_pagamento_banco;
      transaction_amount = result.transaction_amount;
      timeRemaining = result.tempo_restante;
      link_boleto = result.link_boleto;
      //console.log("link boleto: ", link_boleto);
      //console.log(result.date_of_expiration);
      pago = false;
      msgBaixarBoleto = Constantes.msg_boleto_gerado_sucesso;
      messagemExpirado = "";
      //window.open(link_boleto, '_blank');
    } else if (result.status === "approved") {
      pago = true;
      msgAguardandoPagamento = "Pagamento efetuado com sucesso!";
      showModal = true;
    }
    isLoading = false;
  }

 async  function PagamentoCartao() {
    await AtualizaStatus();
    modalCartao = true;
  }
  async  function PagamentoCartaoPro() {
    await AtualizaStatus();

    isLoading=true;
    let conexao = new Conexoes();
    let data = await conexao.conecta(Constantes.api_pagar_cartao_pro, {cod_inscricao_encurtado: cod_inscricao_encurtado})
      if (data.init_point) {
            window.location.href = data.init_point;
      }
     isLoading=false;


  }
  //pagamento
  async function handleSubmit() {
    isLoading = true;
    result = await conexao.conecta(api_pagamento, parametros_pagamento);

    if (result.status === "pending") {
      //console.log("etrou aqui");
      qrCodeBase64 =
        result.point_of_interaction.transaction_data.qr_code_base64;
      pixCode = result.point_of_interaction.transaction_data.qr_code;

      collectorName =
        result.point_of_interaction.transaction_data.bank_info.collector
          .account_holder_name;
      //console.log("PIX Code:", pixCode);
      horaExpiracao = result.date_of_expiration;
      hora_registro = result.hora_criacao_servidor;
      transaction_amount = result.transaction_amount;
      timeRemaining = result.tempo_restante;
      //console.log("tempo restante: ", result.tempo_restante);
      //console.log(result.date_of_expiration);
      pago = false;
      statusPagamento = "Aguardando";
      messagemExpirado = "";
      showModal = true;
      await AtualizaStatus(); 
    } else if (result.status === "approved") {
      pago = true;
      msgAguardandoPagamento = "Pagamento efetuado com sucesso!";
      showModal = true;
    }

    isLoading = false;
  }

  const handlePaymentMethodChange = (method) => {
    paymentMethod = method;

    if (method == "pix") {
      tituloBotao = "Efetuar pagamento com pix";
    } else if (method == "cartao") {
      tituloBotao = "Efetuar pagamento com cartão";
    } 
    else if (method == "cartao_pro") {
      tituloBotao = "Efetuar pagamento com cartão via Mercado Pago";
    }else {
      tituloBotao = "Efetuar pagamento com boleto";
    }
  };

  function BaixarComprovante() {
    window.location.href =
      Constantes.api_gerar_comprovante + cod_inscricao_encurtado;
    showModal = false;
    navigate(
      Constantes.tela_minhas_incricoes +
        "?id=" +
        ArmazenaVariaveisLogin.dados.id_usuario,
    );
  }
async function updateStatus() {
  if(interval){
    clearInterval(interval);
  }
    let result = await conexao.conecta(api_atualiza_pagamento, parametros_pagamento);
    if (result) {
      statusPagamento = result.status;
      if (statusPagamento === "approved" || statusPagamento === "aprovado") {
        pago = true;
        showModal = true;
        clearInterval(interval); // Limpa o intervalo
      } else if (statusPagamento === "cancelled") {
        pago = false;
        showModal = false;
        statusPagamento = "";
        messagemExpirado = "Pagamento expirado! Solicite novamente";
        clearInterval(interval); // Limpa o intervalo
        
      } else if (statusPagamento === "rejected") {
        pago = false;
        showModal = false;
        statusPagamento = "";
        modalCartao=false;
        messagemExpirado = "Pagamento rejeitado! Tente novamente";
        clearInterval(interval); // Limpa o intervalo
        
      }
      
      else{
        interval = setInterval(updateStatus, 11000);
      }
    }
  }
async function AtualizaStatus() {
  // Função para atualizar o status
  

  // Chama updateStatus() imediatamente antes de definir o intervalo
  await updateStatus();

  // Define o intervalo para executar updateStatus() a cada 11 segundos
  
  
}
</script>

<LoadingTela {isLoading} />
{#if messagemExpirado}
  <CaixaDeDialogo
    message={messagemExpirado}
    on:close={() => (messagemExpirado = "")}
  />
{/if}

{#if msgBaixarBoleto}
  <CaixaDeDialogo
    message={msgBaixarBoleto}
    on:close={() => {
      msgBaixarBoleto = "";
      // retorno = "";
    }}
    button1Label={Constantes.botao_cancelar}
    button2Label={Constantes.titulo_ver_boleto}
    button3Label={Constantes.titulo_baixar_boleto}
    button3Action={BaixarBoleto}
    button2Action={VerBoleto}
  />
{/if}
<div class="container espacar">
  <div class="card payment-card position-relative">
    <div class="vertical-divider"></div>
    <div class="row">
      <button
        on:click={() => navigate(voltarPagina)}
        class="btn btn-outline-primary left-button"
      >
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
      <div class="col-md-6">
        <h3>Solicitante</h3>
        <p>{solicitante}</p>
        <h3>Descrição do Item</h3>

        <p>{@html descricao}</p>
        <h5>Valor da inscrição: {valor_formatado}</h5>

        {#if codigo_cupom && desconto_cupom >= 0.001}
          <h6>
            (Desconto do cupom "{codigo_cupom}": - {desconto_cupom_formatado})
          </h6>
          <h6>Valor com o desconto: {preco_com_desconto_cupom_formatado}</h6>
        {/if}

        {#if taxa_inscricao != 0}
          <h6>(+Taxa: {taxa_inscricao_formatado})</h6>
        {/if}
        {#if taxa_percentual != 0}
          <h6>Taxa: {taxa_percentual_formatada}</h6>
        {/if}

        <h4>Valor total: {preco_final_formatado}</h4>
        <hr />
        {#if pago == false}
          <h5>Selecione uma opção de pagamento:</h5>

          <div class="d-flex justify-content-between my-3 payment-method-cards">
            {#if pixHabilitado == "1"}
              <div
                class="card payment-method-card p-3 text-center"
                class:active={paymentMethod === "pix"}
                on:click={() => handlePaymentMethodChange("pix")}
              >
                <i class="fas fa-qrcode icon"></i>
                <p>Pagamento via Pix</p>
              </div>
            {/if}
            {#if boletoHabilitado == "1"}
              <div
                class="card payment-method-card p-3 text-center"
                class:active={paymentMethod === "boleto"}
                on:click={() => handlePaymentMethodChange("boleto")}
              >
                <i class="fas fa-barcode icon"></i>
                <p>Pagamento via Boleto</p>
              </div>
            {/if}
            {#if cartaoHabilitado == "1"}
              <div
                class="card payment-method-card p-3 text-center"
                class:active={paymentMethod === "cartao"}
                on:click={() => handlePaymentMethodChange("cartao")}
              >
                <i class="fas fa-credit-card icon"></i>
                <p>Pagamento via cartão</p>
              </div>
            {/if}
             {#if cartaoHabilitado_pro == "1"}
              <div
                class="card payment-method-card p-3 text-center"
                class:active={paymentMethod === "cartao"}
                on:click={() => handlePaymentMethodChange("cartao_pro")}
              >
                <i class="fas fa-credit-card icon"></i>
                <p>Pagamento via cartão</p>
              </div>
            {/if}
            
          </div>
          {#if paymentMethod}
            {#if paymentMethod == "pix"}
              <Button fullSize on:click={() => handleSubmit()}
                >{tituloBotao}</Button
              >
            {:else if paymentMethod == "cartao"}
              <Button fullSize on:click={() => PagamentoCartao()}
                >{tituloBotao}
              </Button>
              {:else if paymentMethod == "cartao_pro"}
              <Button fullSize on:click={() => PagamentoCartaoPro()}
                >{tituloBotao}
              </Button>
            {:else}
              <Button fullSize on:click={() => PagamentoBoleto()}
                >{tituloBotao}
              </Button>
            {/if}
          {/if}
        {/if}
      </div>
      <div
        class="col-md-6 d-flex flex-column justify-content-center align-items-center text-center h-100"
      >
        <h5>Pagamento feito através de</h5>
        <img
          src={Constantes.logo_mercado_pago}
          alt="Mercado Pago"
          class="logo"
        />

        {#if statusPagamento && pago == false && paymentMethod == "pix"}
          <ModalPix
            msgAguardandoPagamento={statusPagamento}
            {pixCode}
            {horaExpiracao}
            {collectorName}
            {Banco}
            {transaction_amount}
            timeRemaining={tempo}
            {qrCodeBase64}
          />
        {/if}
        {#if link_boleto}
          <a href={link_boleto}>Download do boleto</a>
        {/if}
      </div>
    </div>
  </div>
</div>

<!--Modal do pix-->

{#if showModal}
  <div class="modal">
    {#if pago == false && modalCartao==false}
      <div class="modal-content">
        <span
          class="close"
          on:click={() => {
            ApagaContador();
          }}>&times;</span
        >

        <ModalPix
          {msgAguardandoPagamento}
          {pixCode}
          {horaExpiracao}
          {collectorName}
          {Banco}
          {transaction_amount}
          {qrCodeBase64}
          timeRemaining={tempo}
        />
      </div>
   
    {:else}
      <div class="modal-content">
        <p>
          {mensagem}
        </p>
        <button on:click={BaixarComprovante}>Comprovante de inscrição</button>
      </div>
    {/if}
  </div>
{/if}
 {#if modalCartao==true && pago == false}

      <ModalCartaoCredito
        bind:showModal={modalCartao}
        {cod_inscricao_encurtado}
        valor={preco_final}
        on:pago={()=>updateStatus()}
      />
      {/if}
<style>
  .espacar {
    margin-bottom: 5em;
  }
  .payment-card {
    max-width: 70%;
    margin: 2rem auto;
    padding: 2rem;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }
  .payment-method-card {
    cursor: pointer;
    transition: transform 0.2s;
  }
  .payment-method-card:hover {
    transform: scale(1.05);
  }
  .payment-method-card.active {
    border: 2px solid #007bff;
  }
  .logo {
    max-width: 100px;
  }
  .vertical-divider {
    border-left: 2px solid #ddd;
    height: 70%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 50%;
    display: block; /* Oculta por padrão */
  }
  .icon {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .vertical-divider {
      display: none;
    }
    .payment-method-cards {
      flex-direction: column !important;
    }
    .payment-method-card {
      width: 100% !important;
      margin-bottom: 1rem;
    }
  }
  .modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 1050;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    background-color: #fefefe;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    border-radius: 10px;
    text-align: center;
  }

  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
  /* Estilos semelhantes ao Bootstrap */
</style>
